import script from "./HomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=5268337b&scoped=true&lang=css"

import exportComponent from "P:\\FTH\\Projekte\\GemeindeApp\\97486_Koenigsberg_i_Bay\\Frontend\\svn\\trunk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5268337b"]])

export default __exports__